$(() => {
  if (!$('#mypage-schedules_index').length) {
    if (!$('#mypage-work_schedules_index').length) {
      return
    }
  }

  //
  // 編集ボタン
  //
  $(document).on('click', '.js-edit-work-schedule', function (e) {
    e.stopPropagation(); // ← ★ 親の .js-add-work-schedule クリックを防ぐ！

    const id   = $(this).data('work-schedule-id');
    const date = $(this).data('work-schedule-date');
    const from = $(this).data('work-schedule-from');
    const to   = $(this).data('work-schedule-to');

    $('#js-work-schdule-id').val(id);
    $('#js-work-schdule-date').val(date);
    $('#js-work-schdule-from').val(from);
    $('#js-work-schdule-to').val(to);

    const deleteLink = $('#js-delete-work-schedule');
    const baseUrl = deleteLink.data('base-url');
    deleteLink.attr('href', `${baseUrl}?id=${id}`).show();

    $('#work-calendar-modal').modal('show');
  });

  //
  // Order詳細ボタン
  //
  $(document).on('click', '.js-order-reserved', function (e) {
    e.stopPropagation(); // ← ★ 親の .js-add-work-schedule クリックを防ぐ！
  });

  //
  // 追加ボタン（カレンダー日付クリック）
  //
  $(document).on('click', '.js-add-work-schedule', function (e) {

    const date = $(this).data('work-schedule-date');

    $('#js-work-schdule-id').val('');
    $('#js-work-schdule-date').val(date);
    $('#js-work-schdule-from').val('1000');
    $('#js-work-schdule-to').val('1800');

    $('#js-delete-work-schedule')
      .attr('href', '#')
      .hide();

    $('#work-calendar-modal').modal('show');
  });

  //
  // ignoreボタン（特殊な表示等でイベントを消したい)
  //
  $(document).on('click', '.js-work-schedule-ignore', function(e) {
    e.stopPropagation();
  });
});
